import React, { useState, useEffect } from 'react';
import { Segment, Header, Statistic, Loader, Message, Grid } from 'semantic-ui-react';
import axiosInstance from '../../lib/auth/axiosApi';

const MonarchDashboard = () => {
  const [netWorth, setNetWorth] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchNetWorth();
  }, []);

  const fetchNetWorth = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.get('/monarch/networth/');
      setNetWorth(response.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch net worth');
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  if (loading) {
    return (
      <Segment style={{ minHeight: '200px' }}>
        <Loader active>Loading net worth...</Loader>
      </Segment>
    );
  }

  if (error) {
    return (
      <Message negative>
        <Message.Header>Error</Message.Header>
        <p>{error}</p>
      </Message>
    );
  }

  return (
    <div>
      <Segment textAlign="center" padded="very">
        <Header as="h2">Net Worth</Header>
        <Statistic size="huge" color={netWorth?.netWorth >= 0 ? 'green' : 'red'}>
          <Statistic.Value>
            {formatCurrency(netWorth?.netWorth || 0)}
          </Statistic.Value>
          <Statistic.Label>Total Net Worth</Statistic.Label>
        </Statistic>
      </Segment>

      <Grid columns={2} stackable>
        <Grid.Column>
          <Segment textAlign="center" style={{ padding: '2rem' }}>
            <Statistic color="blue" size="small">
              <Statistic.Value>
                {formatCurrency(netWorth?.assets || 0)}
              </Statistic.Value>
              <Statistic.Label style={{ marginTop: '0.5rem' }}>TOTAL ASSETS</Statistic.Label>
            </Statistic>
          </Segment>
        </Grid.Column>
        <Grid.Column>
          <Segment textAlign="center" style={{ padding: '2rem' }}>
            <Statistic color="orange" size="small">
              <Statistic.Value>
                {formatCurrency(netWorth?.liabilities || 0)}
              </Statistic.Value>
              <Statistic.Label style={{ marginTop: '0.5rem' }}>TOTAL LIABILITIES</Statistic.Label>
            </Statistic>
          </Segment>
        </Grid.Column>
      </Grid>
    </div>
  );
};

export default MonarchDashboard;